export enum OrderStateStatus {
  PLACED = 'placed',
  CANCELED = 'canceled',
  CONFIRMED = 'confirmed',
  SHIPPED = 'shipped',
  WAITING_FOR_PAYMENT = 'waiting_for_payment',
  RETURN_REQUESTED = 'return_requested',
  RETURN_ACCEPTED = 'return_accepted',
  RETURN_DECLINED = 'return_declined',
  MIXED = 'mixed',
  PAID = 'paid',
}
